var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Autocomplete, Button, Option, Select, } from "@mui/joy";
import { useEffect, useState } from "react";
import { useGetModuleListQuery, useSaveAOPCaseUpdatesMutation, } from "@/store/api";
import toast from "react-hot-toast";
import UploadFile from "@/components/dev/upload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { LoaderImage } from "@/utils/loader";
var CaseUpdateForm = function (_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, viewType = _a.viewType, onSaved = _a.onSaved;
    var _b = useState(""), updateText = _b[0], setUpdateText = _b[1];
    var _c = useState(0), key = _c[0], setkey = _c[1];
    var _d = useState(false), isInternal = _d[0], setIsInternal = _d[1];
    var _e = useState([]), files = _e[0], setFiles = _e[1];
    var _f = useState(false), isSaving = _f[0], setIsSaving = _f[1];
    var saveBtn = "Save";
    var saveTitle = "Save your update";
    var mod_strings = {
        LBL_UPDATE_TEXT: "Update Text",
        LBL_INTERNAL: "Internal",
    };
    var _g = useSaveAOPCaseUpdatesMutation(), saveRecordMutaion = _g[0], isLoading = _g[1].isLoading;
    var externalFiles = files
        .filter(function (f) { return f.type === "external" && f.file; })
        .map(function (f) { return ({ name: f.file.name, content: f.content }); });
    var saveRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fieldText, fieldInternal, internalFiles, _a, _b, payload, result, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, 4, 5]);
                    setIsSaving(true);
                    fieldText = "update_text";
                    record[fieldText] = updateText;
                    fieldInternal = "internal";
                    record[fieldInternal] = isInternal;
                    internalFiles = files.filter(function (f) { return f.type === "internal"; });
                    // Add internal file info into `record` as separate keys
                    internalFiles.forEach(function (f, index) {
                        if (f.internal_doc) {
                            var nameKey = "case_update_name_".concat(index);
                            var idKey = "case_update_id_".concat(index);
                            if (!record.hasOwnProperty(nameKey)) {
                                record[nameKey] = f.internal_doc.name;
                            }
                            if (!record.hasOwnProperty(idKey)) {
                                record[idKey] = f.internal_doc.id;
                            }
                        }
                    });
                    _a = record;
                    _b = "case_update_file";
                    return [4 /*yield*/, prepareAttachments(externalFiles)];
                case 1:
                    _a[_b] = _c.sent();
                    payload = __assign({}, record);
                    return [4 /*yield*/, saveRecordMutaion({
                            body: { record: payload },
                        }).unwrap()];
                case 2:
                    result = _c.sent();
                    toast.success("Saved successfully");
                    setFiles([]);
                    setIsInternal(false);
                    setCase_update_form("");
                    setUpdateText("");
                    setkey(function (prev) { return prev + 1; });
                    if (onSaved)
                        onSaved();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    //toast.error(error);
                    console.log(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var addFileRow = function () {
        setFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                id: Date.now(),
                type: "internal",
                file: null,
                internal_doc: null,
            },
        ], false); });
    };
    var removeFileRow = function (id) {
        setFiles(function (prev) { return prev.filter(function (f) { return f.id !== id; }); });
    };
    var handleTypeChange = function (id, value) {
        setFiles(function (prev) {
            return prev.map(function (f) {
                return f.id === id ? __assign(__assign({}, f), { type: value, file: null }) : f;
            });
        });
    };
    var handleFileChange = function (id, file, content) {
        console.log("file", content);
        setFiles(function (prev) {
            return prev.map(function (f) { return (f.id === id ? __assign(__assign({}, f), { file: file, content: content }) : f); });
        });
    };
    var _h = useState(record === null || record === void 0 ? void 0 : record.case_update_form), case_update_form = _h[0], setCase_update_form = _h[1];
    var prepareAttachments = function (files, internalFiles) {
        if (internalFiles === void 0) { internalFiles = []; }
        return __awaiter(void 0, void 0, void 0, function () {
            var internalAttachments, externalAttachments;
            return __generator(this, function (_a) {
                internalAttachments = internalFiles
                    .filter(function (f) { return f.internal_doc; })
                    .map(function (f) { return ({
                    filename: f.internal_doc.name,
                    id: f.internal_doc.id,
                    internal: true,
                }); });
                externalAttachments = files.map(function (file) { return ({
                    filename: file.name,
                    filecontents: file.content,
                    internal: false,
                }); });
                return [2 /*return*/, __spreadArray(__spreadArray([], externalAttachments, true), internalAttachments, true)];
            });
        });
    };
    /*const prepareAttachments = async (
      files: { name: string; content: string }[]
    ) => {
      return files.map((file) => ({
        filename: file.name,
        filecontents: file.content,
      }));
    };*/
    var recordCount = useGetModuleListQuery({
        table: "Documents",
    }).data;
    var _j = useState([]), documents_list = _j[0], setDocuments_list = _j[1];
    useEffect(function () {
        var _a, _b;
        var options = ((_a = recordCount === null || recordCount === void 0 ? void 0 : recordCount.data) === null || _a === void 0 ? void 0 : _a.records) || [];
        setDocuments_list((_b = recordCount === null || recordCount === void 0 ? void 0 : recordCount.data) === null || _b === void 0 ? void 0 : _b.records);
    }, [recordCount]);
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-2 relative text-[var(--colors-label)]" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsx("div", { children: _jsx("label", __assign({ className: " font-medium ", htmlFor: "update_text" }, { children: mod_strings.LBL_UPDATE_TEXT })) }), _jsx("div", { children: _jsx(ReactQuill, { value: updateText, onChange: setUpdateText, placeholder: "Enter content ...", theme: "snow" }) }), _jsxs("div", { children: [_jsx("label", __assign({ className: "font-medium" }, { children: mod_strings.LBL_INTERNAL })), _jsx("input", { id: "internal", type: "checkbox", name: "internal", tabIndex: 0, title: "", value: "1", checked: isInternal, onChange: function (e) {
                            setIsInternal(e.target.checked);
                        } })] }), _jsxs("div", { children: [files.map(function (f, index) {
                        var _a;
                        return (_jsxs("div", __assign({ style: {
                                marginBottom: "1rem",
                                borderBottom: "1px solid #ccc",
                                paddingBottom: "1rem",
                            } }, { children: [_jsxs(Select, __assign({ className: "caseDocumentTypeSelect", value: f.type, onChange: function (e, value) { return handleTypeChange(f.id, value); }, style: { width: "100%", marginBottom: "0.5rem" } }, { children: [_jsx(Option, __assign({ value: "internal" }, { children: "Internal CRM document" })), _jsx(Option, __assign({ value: "external" }, { children: "External file from PC" }))] })), f.type === "internal" ? (
                                // Display a static placeholder layout like the image
                                _jsx(Autocomplete, { placeholder: "Select a document", getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.name) || ""; }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: f.internal_doc || null, onChange: function (event, newValue) {
                                        setFiles(function (prev) {
                                            return prev.map(function (file) {
                                                return file.id === f.id
                                                    ? __assign(__assign({}, file), { internal_doc: newValue }) : file;
                                            });
                                        });
                                        setIsInternal(true);
                                    }, options: documents_list })) : (
                                // File input for external type
                                _jsxs(_Fragment, { children: [_jsx(UploadFile, { onEntriesDroped: function (acceptedFiles) {
                                                var fileEntry = acceptedFiles[0];
                                                var file = (fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file) || null;
                                                handleFileChange(f.id, file, fileEntry.content);
                                            }, className: "justify-right", type: "", labelUpload: "Select file" }), ((_a = f.file) === null || _a === void 0 ? void 0 : _a.name) && (_jsxs("div", __assign({ style: {
                                                marginTop: "0.5rem",
                                                fontSize: "0.9rem",
                                                color: "#333",
                                            } }, { children: ["Selected file: ", _jsx("label", { children: f.file.name })] })))] })), _jsx("button", __assign({ type: "button", onClick: function () { return removeFileRow(f.id); }, style: {
                                        marginTop: "0.5rem",
                                        background: "#aaa",
                                        color: "#fff",
                                        border: "none",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                    } }, { children: "Remove File" }))] }), f.id));
                    }), _jsx("button", __assign({ type: "button", onClick: addFileRow, style: {
                            background: "#34495e",
                            color: "#fff",
                            padding: "5px 10px",
                            border: "none",
                            cursor: "pointer",
                        } }, { children: "ADD FILE" })), _jsx("div", __assign({ className: "mt-4" }, { children: _jsx(Button, __assign({ className: "mt-5 w-[50px]", title: saveTitle, onClick: function (e) {
                                e.preventDefault(); // <-- ADD THIS
                                saveRecord();
                            } }, { children: saveBtn })) }))] })] }), key));
};
export default CaseUpdateForm;
